import React  from 'react';
import { Card, Form, Space } from 'antd';

import { DataTypeSingleMulti, formItemLayout }from '../Common'
import { isEmpty, invalidURI } from 'script/common';

const DocServer = ({t, apps, settingKey, settingData, onSave, alertMessage}) => {
	const initialValues = {
		['single']: settingData.single,
		['multi']: settingData.multi
	}

	const onFinish = (e) => {
		let value = [];
		Object.keys(e.multi).forEach((app) => {
			let defaultValue = null;
			let initValue = null;
			if (!isEmpty(initialValues.multi)) {
				defaultValue = (isEmpty(initialValues.multi[app])) ? null : initialValues.multi[app].default
				initValue = (isEmpty(initialValues.multi[app])) ? null : initialValues.multi[app].value
			}

			let setValue = isEmpty(e.multi[app].value) ? null : e.multi[app].value
			if (invalidURI(setValue)) return alertMessage("The URI format is incorrect.")

			value.push({
				key: settingKey.value + "_"+ app,
				value: (defaultValue === setValue) ? null : setValue
			})
		})
		
		if (!isEmpty(value)) {
			onSave(false, value)
		}
	}

	return (
		<Form {...formItemLayout} onFinish={onFinish} initialValues={initialValues}>
			<Card title={t(settingKey.key)} key={settingKey.key} name={['settingKey']} style={{ margin: 20 }}>
				<DataTypeSingleMulti
					t={t}
					label={'URI'}
					option={false}
					apps={apps}
					settingData={settingData}
					invalid={true}
				/>
				<Space style={{ float: 'right', margin: 20 }}>
					<button className="btn_text_b">{t('user.account.save')}</button>
				</Space>
			</Card>
		</Form>
	)
}

export default DocServer